'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = OptionHeader;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emailStyleTools = require('helpers/emailStyleTools');

var _dateTimeHelper = require('../../../helpers/dateTimeHelper');

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OptionHeader(props) {
  var containerStyle = props.containerStyle,
      textStyle = props.textStyle,
      text = props.text,
      lastDateToPurchase = props.lastDateToPurchase,
      t = props.t;

  var lastDateToPurchaseFormatted = lastDateToPurchase ? _dateTimeHelper2.default.getDate(lastDateToPurchase) : null;
  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'OptionHeader' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, containerStyle, _emailStyleTools.padTen) },
          _react2.default.createElement(
            'table',
            { style: _emailStyleTools.fullMinimal, 'data-component': 'OptionHeader__Sub' },
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { style: _emailStyleTools.noPad },
                  _react2.default.createElement(
                    'span',
                    { style: textStyle },
                    text
                  )
                ),
                lastDateToPurchase && _react2.default.createElement(
                  'td',
                  { style: (0, _extends3.default)({}, _emailStyleTools.noPad, _emailStyleTools.right) },
                  _react2.default.createElement(
                    'span',
                    { style: textStyle },
                    t('air.lastDate'),
                    ' ',
                    lastDateToPurchaseFormatted
                  )
                )
              )
            )
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/common/OptionHeader.jsx
// module id = 235
// module chunks = 0